<template>
  <div class="parent-password-block">
    <div class="parent-password-content">
      <div class="text-center">
        <img alt="logo" src="./../assets/img/logo-new.svg" class="logo">
      </div>
      <div class="parent-password-description">
        <slot />
      </div>
      <div class="parent-password-popup">
        <div class="form-group">
          <label for="parentPass" class="form-label text-white">{{ $lang.messages.passcode }}</label>
          <span class="input-password">
            <input name="passName"
                   autofocus
                   id="parentPass"
                   maxlength="4"
                   :type="inputType"
                   class="form-control -passcode"
                   @input="currentValue = $event.target.value"
                   :placeholder="$lang.messages.kid.login.pas_placeholder"
                   @keyup.enter="checkPassword">
            <button class="btn-icon" @click="pasVisible = !pasVisible">
              <i class="icon-visible" v-if="pasVisible"></i>
              <i class="icon-hidden" v-if="!pasVisible"></i>
            </button>
          </span>
          <div v-if="showError" class="form-error">{{ $lang.messages.app.passcode.wrong_passcode }}</div>
        </div>
        <div class="text-center parent-password-buttons">
          <button v-if="!hideBackButton" @click="$emit('onBackClick')" class="btn btn-outline -shadow mr-1">{{ $lang.messages.cancel }}</button>
          <button @click="checkPassword" class="btn btn-main -shadow">{{ $lang.messages.confirm }}</button>
        </div>
        <div class="text-center mt-1">
          <span class="locked-password-block-link" @click="showHelpBlock = true">{{ $lang.messages.help }}</span>
        </div>
      </div>
    </div>
    <div v-if="showForgot" class="modal" @mousedown.self="showForgot = false">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-title">{{$lang.messages.kid.forgot.forgot_pas}} <span class="modal-close" @click="showForgot = false"><i class="icon-close"></i></span></div>
        <div class="modal-content">
          <div class="login-pass">
            {{ this.forgotPassword ? $lang.messages.kid.forgot.your_pas_is : $lang.messages.kid.forgot.enter_email}}
          </div>
          <div v-if="this.forgotPassword" class="password-show text-center text-huge text-bold">
            {{ passToCheck || "You don't have password" }}
          </div>
          <div v-else class="kid-input-block" :class="{'-error' : errorInEmail}">
            <input type="email" class="input mb-0" v-model="enteredEmail" :placeholder="$lang.messages.kid.forgot.enter_email" @keyup.enter="showPassword">
            <button class="btn btn-main" @click="showPassword">{{ $lang.messages.submit }}</button>
          </div>
          <div class="form-error" v-if="errorInEmail">{{ $lang.messages.kid.forgot.forgot_error }}</div>
        </div>
      </div>
    </div>
    <div v-if="showHelpBlock" class="help-link-block flex-center">
      <div class="back-btn mb-2" @click="showHelpBlock = false">{{ $lang.messages.back }}</div>
      <div class="help-link-block-content">
        <div class="text-center mb-3">
          <img alt="logo" src="./../assets/img/logo-new.svg" class="logo" @click="showHelpBlock = false">
        </div>
        <HelpLinks v-on:goforgot="showForgot = true"/>
      </div>
    </div>
  </div>
</template>

<script>
import HelpLinks from "@/components/HelpLinks";
import {mapState} from "vuex";

export default {
  name: "EnterParentPassword",
  props: ['passToCheck', 'hideBackButton'],
  components: {
    HelpLinks
  },
  data: function () {
    return {
      showError: false,
      showHelpBlock: false,
      showForgot: false,
      currentValue: null,
      errorInEmail: false,
      enteredEmail: null,
      forgotPassword: false,
      pasVisible: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountPassword: state => state.accountData.password,
    }),
    inputType() {
      return this.pasVisible ? 'text' : 'password'
    }
  },
  methods: {
    showPassword() {
      this.errorInEmail = false;
      if (this.user.email === this.enteredEmail) {
        this.forgotPassword = true;
      } else {
        this.errorInEmail = true;
      }
    },
    checkPassword() {
      if (this.currentValue === this.passToCheck) {
        this.$emit('submitSuccess')
      } else {
        this.showError = true;
      }
    }
  }
}
</script>

<style scoped>
.parent-password-description {
  /*min-height: 120px;*/
  margin-bottom: 20px;
}
</style>